import React from 'react';
import {Form} from 'antd';
import {CloseOutlined} from '@ant-design/icons';

const extractCodeAndName = (conceptName) => {
    const match = conceptName?.match(/^(\d+[A-Za-z]+)\s+(.*)/);
    if (match) return {code: match[1], name: match[2]};
    return {code: null, name: conceptName};
};

const SelectionSummary = ({topicGroups}) => {
    const form = Form.useFormInstance();
    const selectedConcepts = Form.useWatch(['selectedConcepts'], form) || {};

    const selectedByTopic = [];
    topicGroups.forEach(tg => {
        tg.topics.forEach(topic => {
            const selected = topic.concepts.filter(c => selectedConcepts[c.conceptId]);
            if (selected.length > 0) {
                selectedByTopic.push({topic, concepts: selected});
            }
        });
    });

    const totalSelected = selectedByTopic.reduce((sum, g) => sum + g.concepts.length, 0);

    const handleRemove = (conceptId) => {
        form.setFieldValue(['selectedConcepts', conceptId], false);
    };

    return (
        <div className={'ch-lesson-planner-selection-summary'}>
            <div className={'ch-lesson-planner-selection-summary-header'}>
                <strong>Your selection</strong>
                <span className={'ch-lesson-planner-selection-summary-count'}>{totalSelected}</span>
            </div>
            <div className={'ch-lesson-planner-selection-summary-body'}>
                {totalSelected === 0 ? (
                    <p className={'ch-lesson-planner-selection-summary-empty'}>No sections selected</p>
                ) : (
                    selectedByTopic.map(({topic, concepts}) => (
                        <div key={topic.topicId} className={'ch-lesson-planner-selection-summary-group'}>
                            <div className={'ch-lesson-planner-selection-summary-topic'}>{topic.topicName}</div>
                            {concepts.map(concept => {
                                const {code, name} = extractCodeAndName(concept.conceptName);
                                return (
                                    <div key={concept.conceptId} className={'ch-lesson-planner-selection-summary-item'}>
                                        {code && (
                                            <span className={'ch-lesson-planner-selection-summary-code'}>{code}</span>
                                        )}
                                        <span className={'ch-lesson-planner-selection-summary-name'}>{name}</span>
                                        <button
                                            type="button"
                                            className={'ch-lesson-planner-selection-summary-remove'}
                                            onClick={() => handleRemove(concept.conceptId)}
                                            aria-label={`Remove ${name}`}
                                        >
                                            <CloseOutlined />
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default SelectionSummary;
